module.exports = __webpack_public_path__ + "static/img/logo_bd.432fdc2.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/sport/logo_bd.png
// module id = 9bzd
// module chunks = 3